import { useRef, useState } from "react";
import "../../../styles/panel/user/DocumentUpload.css";
import sampleFormImageSrc from "../../../assets/images/commitment-template.jpg";
import blankFormImageSrc from "../../../assets/images/commitment-sample.jpg";
import toast, { Toaster } from "react-hot-toast";
const DocumentIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" />
    <path d="M14 2v6h6" />
    <line x1="8" y1="13" x2="16" y2="13" />
    <line x1="8" y1="17" x2="13" y2="17" />
  </svg>
);

const InfoIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="10" />
    <line x1="12" y1="11" x2="12" y2="16" />
    <circle
      cx="12"
      cy="8"
      r="0.5"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);

const HelpIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="10" />
    <path d="M9.3 9a2.7 2.7 0 015.2.9c0 1.8-2.5 1.9-2.5 3.6" />
    <circle cx="12" cy="17" r="0.6" fill="currentColor" stroke="none" />
  </svg>
);

const EyeIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

const DownloadIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M12 3v12" />
    <path d="M7 10l5 5 5-5" />
    <path d="M4 19h16" />
  </svg>
);

const CloudUploadIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M7 18a4.2 4.2 0 01-1-8.27A5.5 5.5 0 0116.4 8.1 4.2 4.2 0 0117 18" />
    <path d="M12 12v8" />
    <path d="M9.2 14.8L12 12l2.8 2.8" />
  </svg>
);

const FileIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" />
    <path d="M14 2v6h6" />
  </svg>
);

const IdCardIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="2" y="5" width="20" height="14" rx="2" />
    <circle cx="8" cy="12" r="2" />
    <line x1="14" y1="9" x2="19" y2="9" />
    <line x1="14" y1="12" x2="19" y2="12" />
    <line x1="14" y1="15" x2="17" y2="15" />
  </svg>
);

const SaveIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M19 21H5a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v11a2 2 0 01-2 2z" />
    <path d="M17 21v-8H7v8" />
    <path d="M7 3v5h8" />
  </svg>
);

export default function DocumentUpload({
  undertakingFile,
  nationalIdFile,
  onUndertakingChange,
  onNationalIdChange,
  onSave,
  // مسیر عکس نمونه‌ی تکمیل‌شده‌ی تعهدنامه و عکس فرم خام - این دو مسیر رو به آدرس واقعی عکس‌هاتون تغییر بدید
}) {
  // const [undertakingFile, setUndertakingFile] = useState(undertakingFile);
  // const [nationalIdFile, setNationalIdFile] = useState(nationalIdFile);
  const [showSample, setShowSample] = useState(false);
  const [showGuide, setShowGuide] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const [isDraggingId, setIsDraggingId] = useState(false);
  const [savedMessage, setSavedMessage] = useState("");
  const [saveState, setSaveState] = useState("idle"); // idle | loading | success
  const [saveError, setSaveError] = useState(false);

  const fileInputRef = useRef(null);
  const idFileInputRef = useRef(null);
  const blankFormLinkRef = useRef(null);

  const isImageFile = (file) => {
    if (!file) return false;

    if (file instanceof File) {
      return file.type.startsWith("image/");
    }

    return /\.(jpg|jpeg|png|gif|webp)$/i.test(file);
  };

  const getFileUrl = (file) => {
    if (!file) return "";

    if (file instanceof File) {
      return URL.createObjectURL(file);
    }

    return file;
  };
  const handleFileChange = (e) => {
    const file = e.target.files?.[0];

    if (file) {
      // setUndertakingFile(file);
      onUndertakingChange?.(file);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => setIsDragging(false);

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);

    const file = e.dataTransfer.files?.[0];

    if (file) {
      // setUndertakingFile(file);
      onUndertakingChange?.(file);
    }
  };

  const handleIdFileChange = (e) => {
    const file = e.target.files?.[0];

    if (file) {
      // setNationalIdFile(file);
      onNationalIdChange?.(file);
    }
  };

  const handleIdDragOver = (e) => {
    e.preventDefault();
    setIsDraggingId(false);

    const file = e.dataTransfer.files?.[0];

    if (file) {
      // setNationalIdFile(file);
      onNationalIdChange?.(file);
    }
  };

  const handleIdDragLeave = () => setIsDraggingId(false);

  const handleIdDrop = (e) => {
    e.preventDefault();
    setIsDraggingId(false);
    const file = e.dataTransfer.files?.[0];
    if (file) onNationalIdChange?.(file);
  };

  const handleSave = async () => {
    if (saveState === "loading") return; // جلوگیری از کلیک تکراری حین ارسال

    setSaveState("loading");

    try {
      // اینجا باید فایل‌ها به سرور ارسال بشه (مثلاً با FormData و fetch/axios)
      // await onSave?.({ undertakingFile, nationalIdFile });
      await onSave?.();

      toast.success("تغییرات با موفقیت ذخیره شد");

      setSaveState("success");
      // setSavedMessage("تغییرات با موفقیت ذخیره شد.");

      setTimeout(() => {
        setSaveState("idle");
        setSavedMessage("");
      }, 2500);
    } catch (err) {
      setSaveState("idle");
      setSaveError(true);
      setSavedMessage("خطا در ذخیره تغییرات. دوباره تلاش کنید.");
      setTimeout(() => {
        setSavedMessage("");
        setSaveError(false);
      }, 3000);
    }
  };

  return (
    <div className="verify-card">
      <Toaster
        position="top-center"
        toastOptions={{
          duration: 3000,
          style: {
            fontFamily: "inherit",
            direction: "rtl",
            fontSize: "13.5px",
          },
        }}
      />
      {/* هدر */}
      <div className="verify-header">
        <div className="verify-header-icon">
          <DocumentIcon />
        </div>
        <div className="verify-header-text">
          <h2>تعهدنامه</h2>
          <p>فرم تعهدنامه را دانلود، تکمیل و تصویر آن را آپلود کنید.</p>
        </div>
      </div>

      {/* راهنمای سریع */}
      <div className="verify-guide-box">
        <div className="guide-top-row">
          <div className="guide-heading">
            <span className="guide-info-icon">
              <InfoIcon />
            </span>
            <h3>راهنمای سریع</h3>
          </div>
          <button
            type="button"
            className="guide-toggle-btn"
            onClick={() => setShowGuide(true)}
          >
            <HelpIcon />
            مشاهده راهنما
          </button>
        </div>
        <p className="guide-desc-inline">
          فرم را دانلود کنید، مطابق نمونه تکمیل نمایید، سپس تصویر فرم تکمیل‌شده
          و تصویر کارت ملی خود را در بخش‌های پایین آپلود کنید.
        </p>
      </div>

      {/* مراحل */}
      <div className="verify-steps-box">
        <div className="verify-steps">
          <div className="verify-step is-active">
            <div className="step-circle">۱</div>

            <div className="step-text">
              <span className="step-title">دانلود فرم</span>
              <span className="step-sub">دریافت فرم خام تعهدنامه</span>
            </div>
          </div>
          <span className="step-arrow">←</span>
          <div className="verify-step">
            <div className="step-circle">۲</div>

            <div className="step-text">
              <span className="step-title">تکمیل فرم</span>
              <span className="step-sub">فرم را طبق نمونه تکمیل کنید</span>
            </div>
          </div>
          <span className="step-arrow">←</span>
          <div className="verify-step">
            <div className="step-circle">۳</div>

            <div className="step-text">
              <span className="step-title">آپلود فرم</span>
              <span className="step-sub">
                تصویر فرم تکمیل‌شده را آپلود کنید
              </span>
            </div>
          </div>
          <span className="step-arrow">←</span>
          <div className="verify-step">
            <div className="step-circle">۴</div>

            <div className="step-text">
              <span className="step-title">آپلود کارت ملی</span>
              <span className="step-sub">تصویر کارت ملی خود را آپلود کنید</span>
            </div>
          </div>
        </div>
      </div>

      <h3 className="verify-section-title">فرم تعهدنامه</h3>

      {/* نمونه و فرم خام */}
      <div className="verify-columns">
        <div className="verify-col">
          <div className="sample-preview" onClick={() => setShowSample(true)}>
            <img
              src={blankFormImageSrc}
              alt="نمونه تکمیل‌شده تعهدنامه"
              className="preview-illustration"
            />
          </div>
          <div className="col-heading">
            <h4>نمونه تکمیل‌شده</h4>
            <p>برای مشاهده نحوه پر کردن</p>
          </div>
          <span className="col-icon" onClick={() => setShowSample(true)}>
            <EyeIcon />
          </span>
          <button
            type="button"
            className="verify-btn outline"
            onClick={() => setShowSample(true)}
          >
            <EyeIcon />
            مشاهده نمونه
          </button>
        </div>

        <div className="verify-col">
          <div
            className="sample-preview"
            onClick={() => blankFormLinkRef.current?.click()}
          >
            <img
              src={sampleFormImageSrc}
              alt="فرم خام تعهدنامه"
              className="preview-illustration"
            />
          </div>
          <div className="col-heading">
            <h4>فرم خام تعهدنامه</h4>
            <p>برای دریافت و چاپ فرم</p>
          </div>
          <span
            className="col-icon"
            onClick={() => blankFormLinkRef.current?.click()}
          >
            <DownloadIcon />
          </span>
          {/* لینک href رو به مسیر فایل واقعی تعهدنامه (مثلاً PDF) تغییر بدید.
              اگه فایل رو مثل عکس‌ها با import اضافه کردید (مثلاً
              import blankFormFile from "../../../assets/files/taahodname-format.pdf"),
              این href رو به {blankFormFile} تغییر بدید تا وبپک/ویت درست باندلش کنه. */}
          <a
            ref={blankFormLinkRef}
            href={sampleFormImageSrc}
            download
            className="verify-btn filled"
          >
            <DownloadIcon />
            دانلود خام
          </a>
        </div>
      </div>

      {/* آپلود مدارک */}
      <div className="verify-uploads-row">
        {/* آپلود تعهدنامه */}
        <div className="verify-upload-section">
          <h3>آپلود تعهدنامه</h3>
          <p>تصویر فرم تکمیل‌شده را در این بخش آپلود کنید</p>

          <div
            className={`dropzone${isDragging ? " is-dragging" : ""}`}
            onClick={() => fileInputRef.current?.click()}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
          >
            {undertakingFile ? (
              <div className="selected-file">
                {isImageFile(undertakingFile) ? (
                  <img
                    src={getFileUrl(undertakingFile)}
                    alt="پیش‌نمایش تعهدنامه"
                    className="file-preview"
                  />
                ) : (
                  <FileIcon />
                )}

                <span>
                  {undertakingFile instanceof File
                    ? undertakingFile.name
                    : "تعهدنامه آپلود شده"}
                </span>
              </div>
            ) : (
              <>
                <div className="dropzone-icon">
                  <CloudUploadIcon />
                </div>

                <p className="dropzone-title">فایل را اینجا بکشید و رها کنید</p>
              </>
            )}

            <input
              ref={fileInputRef}
              type="file"
              accept="image/*,.pdf"
              hidden
              onChange={handleFileChange}
            />
          </div>
        </div>

        {/* آپلود کارت ملی */}
        <div className="verify-upload-section">
          <h3>آپلود کارت ملی</h3>
          <p>تصویر پشت و روی کارت ملی خود را در این بخش آپلود کنید</p>

          <div
            className={`dropzone${isDraggingId ? " is-dragging" : ""}`}
            onClick={() => idFileInputRef.current?.click()}
            onDragOver={handleIdDragOver}
            onDragLeave={handleIdDragLeave}
            onDrop={handleIdDrop}
          >
            {nationalIdFile ? (
              <div className="selected-file">
                {isImageFile(nationalIdFile) ? (
                  <img
                    src={getFileUrl(nationalIdFile)}
                    alt="پیش‌نمایش کارت ملی"
                    className="file-preview"
                  />
                ) : (
                  <FileIcon />
                )}

                <span>
                  {nationalIdFile instanceof File
                    ? nationalIdFile.name
                    : "کارت ملی آپلود شده"}
                </span>
              </div>
            ) : (
              <>
                <div className="dropzone-icon">
                  <CloudUploadIcon />
                </div>

                <p className="dropzone-title">فایل را اینجا بکشید و رها کنید</p>
              </>
            )}
            <input
              ref={idFileInputRef}
              type="file"
              accept="image/*,.pdf"
              hidden
              onChange={handleIdFileChange}
            />
          </div>
        </div>
      </div>

      <button
        type="button"
        className={`verify-save-btn${
          saveState === "loading" ? " is-loading" : ""
        }`}
        onClick={handleSave}
        disabled={saveState === "loading"}
      >
        {saveState === "loading" ? (
          <span className="save-spinner" aria-hidden="true" />
        ) : (
          <SaveIcon />
        )}
        {saveState === "loading" ? "در حال ذخیره..." : "ذخیره تغییرات"}
      </button>

      {savedMessage && (
        <div className={`verify-toast${saveError ? " error" : ""}`}>
          {savedMessage}
        </div>
      )}

      {showGuide && (
        <div
          className="verify-modal-overlay"
          onClick={() => setShowGuide(false)}
        >
          <div className="verify-modal" onClick={(e) => e.stopPropagation()}>
            <button
              className="verify-modal-close"
              onClick={() => setShowGuide(false)}
            >
              ×
            </button>
            <h4>راهنمای آپلود تعهدنامه</h4>
            <p className="guide-desc">
              فرم تعهدنامه را دانلود کنید، پرینت بگیرید، مطابق نمونه تکمیل کنید،
              سپس از آن و از کارت ملی خود عکس گرفته و در بخش‌های آپلود بارگذاری
              نمایید.
            </p>
            <div className="guide-steps">
              <div className="guide-step">
                <span className="step-num">۱</span>
                دانلود و پرینت فرم
              </div>
              <span className="guide-arrow">←</span>
              <div className="guide-step">
                <span className="step-num">۲</span>
                تکمیل مطابق نمونه
              </div>
              <span className="guide-arrow">←</span>
              <div className="guide-step">
                <span className="step-num">۳</span>
                عکس گرفتن و آپلود فرم
              </div>
              <span className="guide-arrow">←</span>
              <div className="guide-step">
                <span className="step-num">۴</span>
                آپلود عکس کارت ملی
              </div>
            </div>
          </div>
        </div>
      )}

      {showSample && (
        <div
          className="verify-modal-overlay"
          onClick={() => setShowSample(false)}
        >
          <div className="verify-modal" onClick={(e) => e.stopPropagation()}>
            <button
              className="verify-modal-close"
              onClick={() => setShowSample(false)}
            >
              ×
            </button>
            <h4>نمونه تکمیل‌شده تعهدنامه</h4>
            <div className="sample-preview large">
              <img
                src={blankFormImageSrc}
                alt="نمونه تکمیل‌شده تعهدنامه"
                className="preview-illustration"
              />
            </div>
            <p>
              فرم را مطابق نمونه بالا تکمیل کرده، امضا کنید و در پایان تصویر آن
              را در بخش آپلود بارگذاری نمایید.
            </p>
          </div>
        </div>
      )}
    </div>
  );
}
